 
import React, { useCallback, useState } from 'react';

import * as Analytics from '../../analytics';

interface Props {
  taggingLabel?: string;
  onBlur?: any;
  onFocus?: any;
  [key: string]: any;
}

const withTaggingFieldChangeHandler = (WrappedComponent: any) =>
  function TaggingFieldChangeClick({
    taggingLabel,
    onBlur,
    onFocus,
    ...rest
  }: Props) {
    const [startTime, setStartTime] = useState(0);
    const handleOnBlur = useCallback(
      (...args) => {
        if (onBlur) {
          onBlur(...args);
        }
        if (taggingLabel) {
          Analytics.sendFieldUpdateEvent(taggingLabel, Date.now() - startTime);
        }
      },
      [onBlur, taggingLabel, startTime],
    );
    const handleOnFocus = useCallback(
      (...args) => {
        if (onFocus) {
          onFocus(...args);
        }
        setStartTime(Date.now());
      },
      [setStartTime, onFocus],
    );
    return (
      <WrappedComponent
        {...rest}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
    );
  };

export default withTaggingFieldChangeHandler;
